<app-dialog-structure
  [title]="data ? 'Edit User' : 'Add User'"
  [submitButton]="data ? 'SAVE' : 'ADD'"
  (cancel)="close()"
  (submit)="save()"
  [disableAction]="userForm.invalid"
  >
  <div [formGroup]="userForm" class="display-layout-column">
    <mat-form-field>
      <mat-label>User Name</mat-label>
      <input matInput formControlName="username" type="text" required />
      @if (userForm.controls['username'].hasError('required')) {
        <mat-error>
          User Name is <strong>required</strong>
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>First Name</mat-label>
      <input matInput formControlName="firstName" type="text" required />
      @if (userForm.controls['firstName'].hasError('required')) {
        <mat-error>
          First Name is <strong>required</strong>
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Last Name</mat-label>
      <input matInput formControlName="lastName" type="text" required />
      @if (userForm.controls['lastName'].hasError('required')) {
        <mat-error>
          Last Name is <strong>required</strong>
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>E-Mail</mat-label>
      <input matInput formControlName="email" type="email" required />
      @if (userForm.controls['email'].hasError('required')) {
        <mat-error>
          E-Mail is <strong>required</strong>
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Password</mat-label>
      <input matInput formControlName="password" type="password" required />
      @if (userForm.controls['password'].hasError('required')) {
        <mat-error>
          Password is <strong>required</strong>
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Roles</mat-label>
      <mat-select formControlName="roles" multiple>
        @for (role of roles; track role) {
          <mat-option [value]="role"
            >{{ role.name }}
          </mat-option>
        }
      </mat-select>

      @if (userForm.controls['roles'].hasError('required')) {
        <mat-error>
          Role is <strong>required</strong>
        </mat-error>
      }
    </mat-form-field>
  </div>
</app-dialog-structure>
